var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0027,
    cy: 19.9973,
    r: 18.9973,
    fill: "#0052FF",
    stroke: "white",
    strokeWidth: 0.775401
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2575 14.3495C30.4668 14.7089 29.6145 14.9451 28.7314 15.058C29.6351 14.5138 30.3333 13.6512 30.6619 12.614C29.8096 13.1275 28.8649 13.4869 27.8688 13.6923C27.0576 12.8092 25.9177 12.2957 24.6239 12.2957C22.2107 12.2957 20.2391 14.2673 20.2391 16.701C20.2391 17.0502 20.2802 17.3891 20.352 17.7074C16.6963 17.5225 13.4411 15.7666 11.2744 13.107C10.8944 13.7539 10.6788 14.5138 10.6788 15.3147C10.6788 16.8448 11.449 18.2003 12.6401 18.9705C11.9111 18.9705 11.2333 18.7651 10.6377 18.457V18.4878C10.6377 20.6237 12.1575 22.4105 14.1702 22.811C13.5241 22.9886 12.8456 23.0132 12.1883 22.8829C12.4672 23.7583 13.0135 24.5243 13.7502 25.0731C14.487 25.622 15.3772 25.9262 16.2959 25.943C14.7388 27.1758 12.8086 27.8421 10.8226 27.8324C10.4734 27.8324 10.1243 27.8119 9.77515 27.7708C11.7262 29.0236 14.047 29.7527 16.532 29.7527C24.6239 29.7527 29.0703 23.0369 29.0703 17.2145C29.0703 17.0194 29.0703 16.8345 29.06 16.6394C29.9226 16.0233 30.6619 15.2429 31.2575 14.3495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d925d53fde394efe2c0fa2cfca053d55.svg";
export { ForwardRef as ReactComponent };